import { Clock } from "lucide-react";
import { ConvoItemProps } from "../../../../views/crm-pages/conversation/types";
import { formatTime, formatWhatsAppWindowCountdown, getColorFromId, getInitials, getStatusBadge } from "../../../../utils/function";
import { Avatar, Badge } from "./avatar";

export const ConvoItem: React.FC<ConvoItemProps> = ({ conv, selected, onClick }) => {
  const initials = getInitials(conv.title);
  const color = getColorFromId(conv.id);
  const time = formatTime(conv.last_message_at);
  const statusInfo = getStatusBadge(conv.status);
  const unreadCount = conv.unread_count || 0;
  const windowCountdown = formatWhatsAppWindowCountdown(conv.whatsapp_window_expires_at, conv.whatsapp_window_status);

  // Safe body extraction
  const lastMessageBody = conv.last_message?.body ?? "No messages yet";
  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-2.5 px-[14px] py-2.5 cursor-pointer rounded-lg mx-1.5 transition-colors duration-150 ${selected ? "bg-indigo-50 dark:bg-indigo-500/10" : "hover:bg-slate-50 dark:hover:bg-gray-800"
        }`}
    >
      <Avatar src={null} initials={initials} color={color} />

      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-center">
          <span className="font-semibold text-[13.5px] text-slate-800 dark:text-gray-100 truncate">
            {conv.title || conv.external_thread_id}
          </span>
          <span className="text-[11px] text-slate-400 dark:text-gray-500 whitespace-nowrap">{time}</span>
        </div>

        <div className="flex justify-between items-center mt-0.5">
          <span className="text-[11px] text-slate-500 dark:text-gray-400 truncate max-w-[160px]">
            {lastMessageBody}
          </span>
          <Badge count={unreadCount} />
        </div>

        <div className="flex justify-between items-center mt-1">
          <span className={`text-[10px] px-1.5 py-0.5 rounded ${statusInfo.className}`}>
            {statusInfo.label}
          </span>
          {windowCountdown ? (
            <span
              className={`text-[10px] px-1.5 py-0.5 rounded-full flex items-center gap-1 whitespace-nowrap ${
                windowCountdown.closed
                  ? "bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400"
                  : windowCountdown.urgent
                  ? "bg-red-50 text-red-600 dark:bg-red-500/15 dark:text-red-400"
                  : "bg-green-50 text-black dark:bg-green-500/15 dark:text-green-400"
              }`}
            >
              <Clock size={10} />
              {windowCountdown.label}
            </span>
          ) : (
            !unreadCount && (
              <span className="text-[10px] text-slate-400 dark:text-gray-500 truncate">
                ID: {conv.external_thread_id}
              </span>
            )
          )}
        </div>
      </div>
    </div>
  );
};